import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from 'inversify';
import dayjs from 'dayjs';
import { Symbols } from '../symbols';
import { mapObjectValues } from '../utils/lang';
/**
 * bo后端系统传api时候需要根据当前的语言给出合适的时间参数
 */
let BoHelperService = class BoHelperService {
    constructor(i18n) {
        this.i18n = i18n;
        this.serializeDate = (date) => {
            if (!date) {
                return date;
            }
            if (!_.isDate(date)) {
                return date;
            }
            const format = 'YYYY-MM-DD';
            return dayjs(date).format(format);
        };
        this.serializeBeginDate = (date) => {
            if (!date) {
                return date;
            }
            if (!_.isDate(date)) {
                return date + ' 00:00:00';
            }
            return this.serializeDate(date) + ' 00:00:00';
        };
        this.serializeEndDate = (date) => {
            if (!date) {
                return date;
            }
            if (!_.isDate(date)) {
                return date + ' 23:59:59';
            }
            return this.serializeDate(date) + ' 23:59:59';
        };
        // #region Helper
        this.maybeSerializeDate = (object, ...keys) => {
            return mapObjectValues(object, keys, this.serializeDate);
        };
        this.maybeSerializeBeginDate = (object, ...keys) => {
            return mapObjectValues(object, keys, this.serializeBeginDate);
        };
        this.maybeSerializeEndDate = (object, ...keys) => {
            return mapObjectValues(object, keys, this.serializeEndDate);
        };
        // #endregion
        // #region url上使用
        this.UrlDateFormat = 'YYYY-MM-DD';
        this.parseUrlDate = (dateStr) => {
            if (!dateStr) {
                return dateStr;
            }
            return dayjs(dateStr, this.UrlDateFormat).toDate();
        };
        this.maybeParseUrlDate = (object, ...keys) => {
            return mapObjectValues(object, keys, this.parseUrlDate);
        };
        this.serializeUrlDate = (date) => {
            if (!_.isDate(date)) {
                return date;
            }
            return dayjs(date).format(this.UrlDateFormat);
        };
        this.maybeSerializeUrlDate = (object, ...keys) => {
            return mapObjectValues(object, keys, this.serializeUrlDate);
        };
        this.maybeSerializeLocaleDate = (object, ...keys) => {
            return mapObjectValues(object, keys, this.serializeLocaleDate.bind(this));
        };
    }
    serializeLocaleDate(dateStr) {
        const date = this.parseUrlDate(dateStr);
        const dataStr = this.serializeDate(date);
        return dataStr;
    }
};
BoHelperService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object])
], BoHelperService);
export { BoHelperService };
